import styled from 'styled-components';
import { theme } from '../../theme';
import { Button } from '../Button';
import { TextField } from '../TextField';
import { BaseContainer } from '../BaseContainer';
const Container = styled(BaseContainer).withConfig({ displayName: "vui--Container", componentId: "vui--18asccd" }) `display:flex;flex-direction:column;position:relative;`;
const Row = styled(BaseContainer).withConfig({ displayName: "vui--Row", componentId: "vui--hefld1" }) `display:flex;flex-direction:row;`;
const StyledTextField = styled(TextField).withConfig({ displayName: "vui--StyledTextField", componentId: "vui--1w2y0ok" }) `&&&{text-align:left;width:52px;}`;
const StyledButton = styled(Button).withConfig({ displayName: "vui--StyledButton", componentId: "vui--fqwvpz" }) `padding:0 4px;border-color:${theme.colors.neutral.ink.lightest};margin-right:4px;${(props) => props.hasError &&
    `
    border-color: ${theme.colors.secondary.red.base};
  `};`;
export { Container, Row, StyledTextField as TextField, StyledButton as Button };
//# sourceMappingURL=styled.js.map